<template>
  <div v-if="value !== 0 && !diaSelecionado.includes('Total:')">
    <v-dialog v-model="dialog" max-width="1200px" scrollable>
      <template v-slot:activator="{ on }">
        <a @click="getTotal" v-on="on">{{ value | localeString }}</a>
      </template>
      <v-card v-if="dialog">
        <v-card-title>
          <span ref="listTitle" class="pa-1 table-card-title"> Cupons emitidos em {{ diaTitle }} </span>
          <v-spacer />
          <v-menu bottom origin="center center" transition="scale-transition">
            <template v-slot:activator="{ on }">
              <mf-button type="icon" icon="more_vert" :loading="csv.loading" color="cinza-0" v-on:click.native="on.click" />
            </template>

            <v-list>
              <v-list-item @click="exportarCsv">
                <v-list-item-title>Exportar CSV</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="clientes"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            :items-per-page-options="rowsPerPageArray"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item['NUM_ANOMESDIA'] }}</td>
                <td>{{ item['COD_ID_LOJA'] }}</td>
                <td>{{ item['COD_CUPOM'] }}</td>
                <td>{{ item['COD_ID_CLIENTE'] | hifen }}</td>
                <td>{{ item['VAL_FATURAMENTO'] | localeString(2) | currency }}</td>
                <td>{{ item['NOM_NOME'] | hifen }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

  <div v-else>
    <span>{{ value | localeString }}</span>
  </div>
</template>

<script>
import { assertArray } from '@/config/helpers.js'
import { listaCuponsCSV } from '@/services/kpis.js'
import { mapActions, mapState } from 'vuex'
import { DateTime } from 'luxon'

export default {
  props: {
    diaSelecionado: String,
    value: Number,
  },
  data() {
    return {
      csv: {
        loading: false,
      },
      dialog: false,
      search: '',
      clientes: [],
      loading: true,
      options: {},
      rowsPerPageArray: [10, 25, 50, 100, { text: 'Todos', value: '' }],
      headers: [
        {
          text: 'Data do cupom',
          width: '10%',
          sortable: false,
        },
        {
          text: 'ID loja',
          width: '10%',
          sortable: false,
        },
        {
          text: 'ID cupom',
          width: '15%',
          sortable: false,
        },
        {
          text: 'ID cliente',
          width: '20%',
          sortable: false,
        },
        {
          text: 'Valor',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Nome',
          width: '30%',
          sortable: false,
        },
      ],
      total: null,
    }
  },
  computed: {
    ...mapState({ stateFilters: (state) => state.filters }),
    filter() {
      return {
        date: this.diaSelecionado,
        unidades: this.stateFilters.unitsConfiguration,
        tipo_pessoa: this.stateFilters.pessoa,
        categoria_cliente: this.stateFilters.cliente,
        fidelidade: this.stateFilters.fidelidade,
        segmentos: this.stateFilters.segments,
        produto: this.stateFilters.products,
      }
    },
    diaTitle() {
      return DateTime.fromFormat(this.diaSelecionado, 'yyyy-MM-dd').toFormat("d 'de' MMMM 'de' yyyy")
    },
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi().then((clientes) => {
          this.clientes = assertArray(clientes)
        })
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions(['listaCupons']),
    redirectCliente(param) {
      this.$router.push({ path: `/clientes/detalhes-cliente/${param}` }).catch(() => {})
    },
    getTotal() {
      this.listaCupons({ data_type: 'size', ...this.filter }).then((quantidade) => {
        this.total = quantidade['NUM_SIZE']
      })
    },
    getDataFromApi() {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { page, itemsPerPage } = this.options
        this.listaCupons({ page: page, page_size: itemsPerPage, ...this.filter }).then((clientes) => {
          this.loading = false
          resolve(clientes)
        })
      })
    },
    exportarCsv() {
      this.csv.loading = true
      let dataFormatada = DateTime.fromFormat(this.diaSelecionado, 'yyyy-MM-dd').toFormat('dd-MM-yy')
      listaCuponsCSV({ send_file: true, ...this.filter }, `cupons-${dataFormatada}`).then(() => {
        this.csv.loading = false
      })
    },
  },
}
</script>
